import { Routes } from '@models/route';
import { lazy } from 'react';

const ListTenants = lazy(() =>
  import('@pages/tenants/list-tenants').then((p) => ({
    default: p.ListTenants
  }))
);

const ViewTenant = lazy(() =>
  import('@pages/tenants/view-tenant').then((p) => ({
    default: p.ViewTenant
  }))
);

const ViewTenantConfig = lazy(() =>
  import('@pages/tenants/view-tenant-config').then((p) => ({
    default: p.ViewTenantConfig
  }))
);

export const TenantRoutes: Routes = [
  {
    path: '/tenants',
    component: ListTenants,
    children: [
      {
        path: ':id/config/:serviceName',
        component: ViewTenantConfig
      },
      {
        path: ':id',
        component: ViewTenant
      }
    ]
  }
];
